import React from 'react';
import './StickTile.css';
import { BsDownload } from 'react-icons/bs';
import icon from "./pivicon.png";
import {Link} from 'react-router-dom';

const stickTile = (props) => {

    

    if (props.pivicon) {

        return (

            <div title={props.name} className="StickTile">
                <Link to={props.search+'/id='+ props.id} stkId={ props.id}>
                    <img  onClick={props.imgclick} className="StickPic" src= {props.pic} alt={props.name}/>
                </Link>
                <img src={icon} className="PivIcon" ></img>
                <a href={props.stk} download>
                    <BsDownload className="DownloadIcon"  />
                </a>
                

            </div>
        )
    } else {
        return (
            <div title={props.name} className="StickTile">
                <Link to={props.search+'/id='+ props.id} stkId={props.id}>
                <img onClick={props.imgclick} className="StickPic" src= {props.pic} alt={props.name}/>
                </Link>
                <a href={props.stk} download>
                    <BsDownload className="DownloadIcon" />
                </a>

                

            </div>
        )

    }
};

export default stickTile;
